import { PreviewImportedCrossesModel } from './preview-imported-crosses.model';

export class ImportCrossesRequestModel {
    constructor(
        public breedingMethodId: number,
        public hasMultiFemaleParents: boolean,
        public hasMultiMaleParents: boolean,
        public basedOnImportFiles: boolean,
        public useParentalStatus: boolean,
        public rawBreedingMethodList: string[],
        public importedCrossList: PreviewImportedCrossesModel[]
    ) {
    }
}
